export default __webpack_public_path__ + "static/media/toilettes.74e34449.svg";